<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
    <p style="font-weight: bold; font-size:2rem; color: white; position: absolute; white-space: nowrap; text-align: center; width: 100%; left: -8px; top: 120px;">{{loadingMessage}}</p>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
  <!--MAIN-->
  <div class="m-content">
    <!--begin::Portlet-->
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">

              <h3 class="m-portlet__head-text" *ngIf="!serviceId">
                LIGHT SHOW DETAILS
              </h3>
              <h3 class="m-portlet__head-text" *ngIf="serviceId > 0">
                EDIT LIGHT SHOW
              </h3>

            <span style="color: lightgray; vertical-align: middle; display: table-cell; text-align: right;" class="m-portlet__head-text" *ngIf="serviceId > 0">
              {{serviceId}}
            </span>

          </div>
          <div style="display: flex; justify-content: space-between;">
            <button (click)="copyLightShowToLibTrack()" style="margin-top: -15px;" class="btn btn-primary" *ngIf="hasSiteManagement && serviceId > 0">
              Copy Lightshow to Library Track
            </button>
            <button (click)="copyUrl()" style="margin-top: -15px;" class="btn btn-primary" *ngIf="hasSiteManagement && serviceId > 0" ngxClipboard [cbContent]="fileDownloadUrl">
              {{ copyUrlPrompt }}
            </button>
        </div>
        </div>
      </div>

      <!--begin::Form-->
      <form
        [formGroup]="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Light Show Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="lightShowName"
                  type="text"
                  id="name"
                  class="form-control m-input"
                  placeholder=""
                />
                <app-validation-display
                  [control]="form.controls.lightShowName"
                ></app-validation-display>
              </div>
            </div>

            <div
              *ngIf="!editMode && showServicePeriod"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Period:
              </label>
              <div class="col-lg-8">
                <app-service-period
                  formControlName="period"
                  [minDays]="30"
                ></app-service-period>
                <div
                  *ngIf="hasSiteManagement && lightShowOwnerHasSubscription"
                  style="width: 50%"
                  >The light show period can only be changed by editing the subscription period of the user {{ lightShowOwner.email }}
                </div>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Light Show Type:
              </label>

              <div (click)="showDataLossDialog($event)" class="col-lg-4" id="type">
                <select
                  formControlName="lightShowTypeCode"
                  class="form-control m-input"
                  id="typeselect1"
                  name="lightShowTypes"
                >
                  <option disabled selected value="null"
                    >-- Select an Option --</option
                  >
                  <option
                    style="color:black;"
                    *ngFor="let type of lightShowTypes"
                    [selected]="
                      type.code == form.controls.lightShowTypeCode.value
                    "
                    [ngValue]="type.code"
                  >
                    {{ type.name }}
                  </option>
                </select>
                <app-validation-display
                  [control]="form.controls.lightShowTypeCode"
                ></app-validation-display>
              </div>
            </div>

            <div
              class="form-group m-form__group row"
              [hidden]="
                form.controls.lightShowTypeCode.value !== '1A' &&
                form.controls.lightShowTypeCode.value !== '1B'
              "
            >
              <label class="col-lg-4 col-form-label">
                Light Show Track:
              </label>
              <div (click)="showDataLossDialog($event)" class="col-lg-4" id="track">
                <a
                  *ngIf="editMode"
                  href="#"
                  class="m-portlet__nav-link m-portlet__nav-link--icon"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Edit
                </a>
                <mat-select
                  #libraryTrackSelect
                  class="form-control m-input"
                  [formControl]="form.controls.trackId"
                  placeholder="-- Select a Track --"
                  (selectionChange)="selectNewTrack()"
                  #singleSelect>
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="form.controls.trackFilter"
                      (ngModelChange)="filterLightShowTracks($event)"
                      noEntriesFoundLabel="'No matching tracks found'"
                      placeholderLabel="Search Tracks..."></ngx-mat-select-search>
                  </mat-option>
                    <mat-optgroup *ngFor="let group of trackGroups" [label]="group.group">
                      <mat-option
                      *ngFor="let track of group.children"
                      [hidden]="!track.visible"
                      [value]="track.trackId">
                      {{ track.title }}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
                <app-validation-display
                  [control]="form.controls.trackId"
                ></app-validation-display>
              </div>
            </div>

            <div
              class="m-form m-form--fit m-form--label-align-left"
              *ngIf="form.controls.lightShowTypeCode.value == '2A'"
            >
              <div class="m-portlet__body">
                <div class="form-group m-form__group row">
                  <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
                    <ng-template #customTrackToolTip>
                      Custom tracks and video audio will be programmed a maximum
                      of 2:30 seconds. If your track exceeds this length only
                      the first 2:30 will be programmed with a light show and on
                      screen content.
                    </ng-template>
                    <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      class="tooltip-icon"
                      placement="top"
                      [tooltip]="customTrackToolTip"
                    />
                    Custom Light Show Track:
                    <br />
                  </label>
                  <div class="col-lg-6 col-md-9 col-sm-12">
                    <app-file-upload
                      multiple="false"
                      (filesSet)="trackFileChanged($event)"
                      [text]="
                        form.controls.uploadedTrackName.value !== null
                          ? form.controls.uploadedTrackName.value
                          : 'Choose file'
                      "
                      accept=".mp3"
                    ></app-file-upload>
                    <input type="hidden" formControlName="uploadedTrackName" />
                    <span class="m-form__help">
                      Supported format is mp3
                    </span>
                    <br />
                    <app-validation-display
                      [control]="form.controls.uploadedTrackName"
                      errorMessage="Please choose a track with the supported format"
                    ></app-validation-display>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="m-form m-form--fit m-form--label-align-left"
              *ngIf="
                form.controls.lightShowTypeCode.value == '1B' ||
                form.controls.lightShowTypeCode.value == '2B'
              "
            >
              <div class="m-portlet__body">
                <div class="form-group m-form__group row">
                  <label
                    class="col-form-label col-lg-4 col-md-4 col-sm-12 video-label"
                  >
                    Video:
                    <br />
                  </label>
                  <div class="col-lg-6 col-md-9 col-sm-12">
                    <a
                      (click)="setUpdateType('video')"
                      *ngIf="editMode"
                      href="#"
                      class="m-portlet__nav-link m-portlet__nav-link--icon"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      Edit
                    </a>
                    <br />
                    <app-file-upload
                      multiple="false"
                      (filesSet)="videoFileChanged($event)"
                      [text]="
                        form.controls.uploadedVideoName.value !== null
                          ? form.controls.uploadedVideoName.value
                          : 'Choose file'
                      "
                      accept=".mp4"
                    ></app-file-upload>
                    <input type="hidden" formControlName="uploadedVideoName" />
                    <span class="m-form__help">
                      Supported formats are MP4 and AVI
                    </span>
                    <br />
                    <app-validation-display
                      [control]="form.controls.uploadedVideoName"
                      errorMessage="Please choose a video file with a supported format"
                    ></app-validation-display>
                  </div>
                </div>
              </div>
            </div>
            <div class="m-form m-form--fit m-form--label-align-right">
              <div
                class="form-group m-form__group row"
                *ngIf="
                  (selectedTrack && (form.controls.lightShowTypeCode.value === '1A' || form.controls.lightShowTypeCode.value === '1B')) ||
                  ((form.controls.lightShowTypeCode.value === '2A' || form.controls.lightShowTypeCode.value === '2B') && selectedTrack && (canProgramCustomTracks || selectedTrack?.hasLightShow))
                "
              >
                <label class="col-lg-2 col-form-label"> </label>
                <div class="col-lg-12">
                  <app-lightshow-preview
                    #lightshowPreview
                    [track]="selectedTrack || customTrack"
                    [selectTrack] = selectTrack
                    [form]="form.controls.assetData"
                    [lightShowTypeCode]="form.controls.lightShowTypeCode.value"
                    [lightShowId]="id"
                    (saveLightShow)="saveCurrentLightShow()"
                    [venueId]="form.controls.venueId.value ? form.controls.venueId.value : 0"
                    (selectedVenue)="selectedVenueChange($event)"
                    [hasSiteManagement]="hasSiteManagement"
                    [enableVenueEdit]="canEditVenues"
                    (saveLibTrackChanges)="saveLibTrackChanges = $event"
                    [serviceFiles]="serviceFiles"
                    [lightShowOwnerEngine]="lightShowOwner?.engine"
                  ></app-lightshow-preview>
                </div>
              </div>
            </div>

            <div
              class="form-group m-form__group row"
              *ngIf="hasSiteManagement"
            >
              <label class="col-lg-4 col-form-label">
                <img
                src="../../assets/app/media/img/icons/info-icon.png"
                class="tooltip-icon"
                style="position: relative;"
                tooltip="This optional field adds a delay to the show based on your venue size to help better synchronize the lights with the music. Recommended if you have a large venue, such as a stadium."
                />
                Distance From Speakers To Audience (ft):
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="delayDistance"
                  class="form-control m-input"
                  formControlName="delayDistance"
                  placeholder=""
                />
                <app-validation-display
                  errorMessage="Please provide a valid distance in ft"
                  [control]="form.controls.delayDistance"
                ></app-validation-display>
              </div>
              <img
                  src="../../assets/app/media/img/icons/eye_x.png"
                  class="admin-only"
                  style="position: relative; top: 0;"
                  tooltip="This field is only visible to admins."
                />
            </div>

              <div
              class="form-group m-form__group row"
            >

              <label class="col-lg-4 col-form-label">
                End of Light Show Redirect:
              </label>
              <div class="col-lg-4">
                <select
                  class="form-control m-input"
                  id="redirectType"
                  name="redirectType"
                  formControlName="redirectType"
                  (change)=redirectChange($event)
                >
                  <option selected value="0">No Redirection</option>
                  <option value="1">Participation Coupon</option>
                  <option value="2">Open Browser to URL</option>
                  <option value="3">UPN</option>
                  <option value="4">Reward Random Participants</option>
                  <option value="5">SMS URL</option>
                  <option value="6">Selfie Cam</option>
                </select>
              </div>
            </div>
            <div
              *ngIf="form.controls.redirectType.value == 2"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Redirect URL:
              </label>
              <div class="col-lg-4">
                <input
                  [requiredIf]="form.controls.redirectType.value == 2"
                  type="text"
                  id="redirectUrl"
                  class="form-control m-input"
                  formControlName="redirectUrl"
                  placeholder=""
                  (blur)="validateUrl()"
                />
                <app-validation-display
                  errorMessage="Please enter a valid URL"
                  [control]="form.controls.redirectUrl"
                ></app-validation-display>
              </div>
            </div>
            <div
              *ngIf="form.controls.redirectType.value == 2 || form.controls.redirectType.value == 5"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Redirect Alert Title:
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="redirectUrl"
                  class="form-control m-input"
                  formControlName="alertTitle"
                  placeholder=""
                />
                <app-validation-display
                  *ngIf="form.controls.redirectType.value == 5"
                  [control]="form.controls.alertTitle"
                  errorMessage="Please enter a title between 1 and 45 characters in length."
                ></app-validation-display>
              </div>
            </div>
            <div
              *ngIf="form.controls.redirectType.value == 2 || form.controls.redirectType.value == 5"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Redirect Alert Body:
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="redirectUrl"
                  class="form-control m-input"
                  formControlName="alertBody"
                  placeholder=""
                />
                <app-validation-display
                  *ngIf="form.controls.redirectType.value == 5"
                  [control]="form.controls.alertBody"
                  errorMessage="Please enter a message between 1 and 150 characters in length."
                ></app-validation-display>
              </div>
            </div>
            <div
              *ngIf="form.controls.redirectType.value == 2 || form.controls.redirectType.value == 5"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Redirect Alert Confirm Button:
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="redirectUrl"
                  class="form-control m-input"
                  formControlName="alertButtonTitle"
                  placeholder="OK"
                />
                <app-validation-display
                  *ngIf="form.controls.redirectType.value == 5"
                  [control]="form.controls.alertButtonTitle"
                  errorMessage="Please enter a message between 1 and 150 characters in length."
                ></app-validation-display>
              </div>
            </div>
            <app-coupon-select
              *ngIf="form.controls.redirectType.value == 1"
              (change)="couponChange()"
              [couponSelectLabel]="'Participation Coupon'"
              [(selectedCouponId)]="form.controls.couponId.value"
            ></app-coupon-select>
            <div
              *ngIf="form.controls.redirectType.value == 3"
              class="form-group m-form__group row"
            >
            <label class="col-lg-4 col-form-label">
              Add UPN:
            </label>
              <div class="col-lg-4" formGroupName="assetData">
                <select
                  class="form-control m-input"
                  formControlName="upnId">
                  <option
                      [ngValue]="0">
                      -- Reset Selection --
                  </option>
                  <option *ngFor="let upn of upns"
                      [ngValue]="upn.id">
                      {{upn.name}}
                  </option>
                 </select>
                <app-validation-display
                    [control]="form.controls.assetData.controls.upnId"
                    errorMessage="Please select a UPN"
                ></app-validation-display>
              </div>
            </div>
            <div
            *ngIf="form.controls.redirectType.value == 4"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Number of winners:
            </label>
            <div class="col-lg-2">
              <div style="display: flex; align-items: center;">
                <input
                  formControlName="numberOfWinners"
                  type="number"
                  class="form-control"
                />
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  class="tooltip-icon"
                  tooltip="The number of participants you want to reward at the end of the light show."
                />
              </div>
              <app-validation-display
                  [control]="form.controls.numberOfWinners"
                  errorMessage="Please enter a number of winners greater than 0."
              ></app-validation-display>
            </div>
          </div>
          <div
            *ngIf="form.controls.redirectType.value == 4"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Winner message:
            </label>
            <div class="col-lg-6">
                <input
                  formControlName="winnerMessage"
                  type="text"
                  class="form-control"
                />
              <app-validation-display
                [control]="form.controls.winnerMessage"
                errorMessage="Please enter a message between 1 and 150 characters in length."
            ></app-validation-display>
            </div>
          </div>
          <div
            *ngIf="form.controls.redirectType.value == 5"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Receiving Phone Number:
            </label>
            <div class="col-lg-4">
                <input
                  formControlName="smsReceivingPhoneNumber"
                  type="number"
                  class="form-control"
                />
              <app-validation-display
                [control]="form.controls.smsReceivingPhoneNumber"
                errorMessage="Please enter a valid phone number. Do not include spaces or hyphens. Country code is required."
            ></app-validation-display>
            </div>
          </div>
          <div
            *ngIf="form.controls.redirectType.value == 5"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              SMS Message:
            </label>
            <div class="col-lg-4">
                <textarea
                  formControlName="smsMessage"
                  type="text"
                  class="form-control"
                ></textarea>
              <app-validation-display
                [control]="form.controls.smsMessage"
                errorMessage="Please enter a message between 1 and 150 characters in length."
            ></app-validation-display>
            </div>
          </div>
          <div
            *ngIf="form.controls.redirectType.value == 4"
            class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"> Notification Emails: </label>
            <div class="col-lg-6">
              <div style="display:flex;align-items:center;">
                <ng-select
                  [addTag]="true"
                  [multiple]="true"
                  [hideSelected]="true"
                  formControlName="listOfEmails"
                  bindLabel="label"
                >
                </ng-select>
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  class="tooltip-icon"
                  tooltip="A list of all user data submitted, including a list of winners
                , will be emailed to this address immediately following the end of the lightshow"
                />
              </div>
              <span
                class="m-form__help"
                style="color:red;"
                *ngIf="!form.controls.listOfEmails.valid && (form.controls.listOfEmails.dirty || form.controls.listOfEmails.touched)"
              >
                Please remove any invalid or duplicate emails.
              </span>
            </div>
          </div>
            <div
              [hidden]="form.controls.couponId.value < 1"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Coupon Message Title:
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="alertTitle"
                  class="form-control m-input"
                  formControlName="alertTitle"
                  placeholder=""
                />
              </div>
            </div>
            <div
              [hidden]="form.controls.couponId.value < 1"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Coupon Message Body:
              </label>
              <div class="col-lg-4">
                <input
                  type="text"
                  id="alertBody"
                  class="form-control m-input"
                  formControlName="alertBody"
                  placeholder=""
                />
              </div>
            </div>
            <div
              *ngIf="form.controls.redirectType.value == 6"
              class="form-group m-form__group row"
            >
            <label class="col-lg-4 col-form-label">
              Add Selfie Cam:
            </label>
              <div class="col-lg-4">
                <select
                  class="form-control m-input"
                  formControlName="selfieCamId">
                  <option
                      [ngValue]="0">
                      -- Reset Selection --
                  </option>
                  <option *ngFor="let selfieCam of selfieCams"
                      [ngValue]="selfieCam.id">
                      {{selfieCam.name}}
                  </option>
                 </select>
                <app-validation-display
                    [control]="form.controls.selfieCamId"
                    errorMessage="Please select a Seflie Cam"
                ></app-validation-display>
              </div>
            </div>
            <div
              *ngIf="hasSiteManagement && id > 0"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Regenerate Audio on Update:
              </label>
              <div class="col-lg-6">
                <label class="switch">
                  <input
                    formControlName="regenerateAudio"
                    type="checkbox"
                    class="form-control"
                  />
                  <span class="slider round"></span>
                </label>
                <img
                  src="../../assets/app/media/img/icons/eye_x.png"
                  class="admin-only"
                  style="position: relative;"
                  tooltip="This field is only visible to admins."
                />
              </div>
            </div>
            <div
            *ngIf="hasSiteManagement"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Use Audible Triggers:
            </label>
            <div class="col-lg-6">
              <label class="switch">
                <input
                  formControlName="useAudible"
                  type="checkbox"
                  class="form-control"
                />
                <span class="slider round"></span>
              </label>
              <img
                  src="../../assets/app/media/img/icons/eye_x.png"
                  class="admin-only"
                  style="position: relative;"
                  tooltip="This field is only visible to admins."
                />
            </div>
          </div>
            <div
              *ngIf="hasSiteManagement"
              class="form-group m-form__group row"
            >
            <label class="col-lg-4 col-form-label">
              Trigger Insertion Pattern:
            </label>
            <div class="col-lg-4">
              <input
                type="text"
                id="insertionPattern"
                autocomplete="false"
                class="form-control m-input"
                formControlName="insertionPattern"
                placeholder=""
              />
              <app-validation-display
                  errorMessage="Invalid insertion pattern list. ex 1, 2, 3"
                  [control]="form.controls.insertionPattern"
                ></app-validation-display>
            </div>
            <img
                  src="../../assets/app/media/img/icons/eye_x.png"
                  class="admin-only"
                  style="position: relative; top: 0;"
                  tooltip="This field is only visible to admins."
                />
            </div>
          </div>
        </div>
      </form>

      <div class="m-portlet__body" style="padding:0 30px 30px 30px">
        <div class="form-group m-form__group row">
          <label class="col-lg-4 col-form-label" style="text-align: right;">
            Coupon Code:
          </label>
          <div class="col-lg-1">
            <app-coupon-code [(ngModel)]="couponCode"></app-coupon-code>
          </div>
          <img
            *ngIf="couponValid && priceFetched"
            src="../../assets/app/media/img/icons/checked.svg"
            style="height: 100%; width:35px;"
          />
        </div>
      </div>
      <div class="m-portlet__body" style="padding:0 30px 30px 30px">
        <div
          *ngIf="hasSiteManagement && id > 0"
          class="form-group m-form__group row"
        >
          <label class="col-lg-4 col-form-label" style="text-align: right;">
            Notify Creator:
          </label>
          <div class="col-lg-6">
            <label class="switch">
              <input
                [(ngModel)]="notifyCreator"
                type="checkbox"
                class="form-control"
              />
              <span class="slider round"></span>
            </label>
            <img
                src="../../assets/app/media/img/icons/eye_x.png"
                class="admin-only"
                style="position: relative;"
                tooltip="This field is only visible to admins."
              />
          </div>
        </div>
      </div>
      <div
        class="modal"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Payment Required
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <span>This action requires payment. Continue?</span>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                (click)="openUpdatePaymentPrompt()"
                class="btn btn-primary"
              >
                Yes
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                id="closePurchaseEditModal"
                data-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button [disabled]="loading" type="submit" (click)="checkout()" class="btn btn-primary">
          {{ id ? "Update" : "Create" }}
        </button>
        <button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
          Cancel
        </button>
        <app-network-sync (showSpinner)="setSpinnerState($event)" (spinnerMessage)="setLoadingMessage($event)" [serviceId]="serviceId" [displayCountdown]="true" [viewRef]="viewRef" [serviceName]="'Light Show'" [controllerPath]="'light-show'"></app-network-sync>
        <div *ngIf="hasValidationErrors">
          <span style="color:red">{{ validationErrorMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
